import { useState } from 'react';
import { useFamilyStore } from '@/store/familyStore';
import { useAuthStore } from '@/store/authStore';
import { AddRequest } from '@/types';

export function useRequests() {
  const { requests, updateRequestStatus, addMember, updateMember, members } = useFamilyStore();
  const user = useAuthStore((state) => state.user);
  const [selectedRequest, setSelectedRequest] = useState<AddRequest | null>(null);

  const handleApprove = (requestId: string, updates?: Partial<AddRequest>) => {
    const request = requests.find((r) => r.id === requestId);
    if (request && user?.role === 'admin') {
      // Create new member with updated data if provided
      const newMemberId = crypto.randomUUID().replace(/[-]/g, "");
      const newMember = {
        id: newMemberId,
        name: updates?.childName || request.childName,
        parentId: updates?.parentId || request.parentId,
        children: [],
      };

      // Add new member
      addMember(newMember);

      // Update parent's children array if parent exists
      if (newMember.parentId) {
        const parent = members.find(m => m.id === newMember.parentId);
        if (parent) {
          updateMember(parent.id, {
            children: [...parent.children, newMemberId]
          });
        }
      }

      // Update request status
      updateRequestStatus(requestId, 'approved');
      setSelectedRequest(null);
    }
  };

  const handleReject = (requestId: string) => {
    if (user?.role === 'admin') {
      updateRequestStatus(requestId, 'rejected');
    }
  };

  return {
    requests,
    selectedRequest,
    setSelectedRequest,
    handleApprove,
    handleReject,
  };
}